import { Component, Inject, SecurityContext, ViewChild, OnInit, ElementRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { JoiEvent } from 'src/app/store/events.era';
import { FormsModule, ReactiveFormsModule, UntypedFormControl } from '@angular/forms';
import { addScriptToDocumentBySource, sleepForMS } from '../../helpers/helpers';
import {  DialogWrapperComponent } from 'src/app/components/wrappers/dialog-wrapper.component';
import { removeFromListByIndex } from '../../helpers/helpers';
import { ConfirmDeleteData, openConfirmDeleteGetResult } from 'src/app/components/dialog.confirmDelete.component';
import { Venue } from 'globals/store/events.data';
import { getEmbeddedMapLinkFromVenue, PlaceResult } from 'globals/store/programs.data';
import { environment } from '../../../../src/environments/environment';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Wrapper } from 'src/app/components/wrapper.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { AddManageWrapperComponent } from 'src/app/components/wrappers/add-manage-wrapper.component';
import { IconComponent } from 'src/app/components/icon/icon.component';
import { CommonModule } from '@angular/common';
import { createId, jsonCopyObject, makeMapFromListOfObjectsAndKey } from 'globals/helpers/helpers';
import { DialogPositionNumbers } from 'globals/store/dialog.selector.data';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';


@Component({
    selector: 'venue-select-dialog',
    template: `
<dialog-wrapper
  [dialogTitle]="isNew ? 'New ' + data.type : mode === 'edit' ? 'Edit ' + data.type : data.type + 's'"
  [titleHeight]="40"
  [hideBottom]="mode === 'select' || !googleMapsLink || mode === 'replace'"
  [showClose]="mode === 'select'"
  [smallTitle]="true"
  [data]="data"
  [tiny]="true"
  [giveMeTwenty]="true"
  [showBack]="mode !== 'select'"
  [successLabel]="isNew ? 'CREATE' : 'SAVE'"
  [deleteLeft]="mode === 'edit'"
  [disabled]="mode !== 'select' && !editingVenue.venue"
  (close)="close()"
  (submit)="dialogSubmit()"
  (back)="revertMode()"
  (delete)="deleteVenue($event)"
>
<ng-container *ngIf="mode !== 'select'">
  <div class="venue-select-wrapper">
    <div class="with-fake-button" *ngIf="mode == 'search' || mode == 'replace'">
      <h4 *ngIf="mode == 'replace'" class="giveme10under">
        Searching for a venue to replace {{ editingVenue.venue }}
      </h4>
      <form>
        <mat-form-field class="general">
          <input #searchInput type="text" matInput autocomplete="off"
            placeholder="Search for venue or address"    
            [formControl]="venueSearchControl">
        </mat-form-field>
      </form>
      <div class="next_fake">
        <button mat-button color="primary" [disabled]="!venueSearchControl.value" (click)="searchForPlace()">Search Google</button>
      </div>
    </div>
    <div class="result_wrapper" *ngIf="mode == 'results'">
      <div class="results_heading">
        <div>Closest result for: <strong>{{ venueSearchControl.value }}</strong></div>
      </div>
      <div class="results">
        <h5 *ngIf="!results && !noResultsMessage && !resultsErrorMessage">Loading...</h5>
        <ng-container *ngIf="results">
          <div class="select_to_continue">Select to continue:</div>
          <div class="result" *ngFor="let result of results" (click)="choosePlace(result)">
            <div class="name">{{ result.name }}</div>
            <div class="address dim">{{ result.formatted_address }}</div>
          </div>
        </ng-container>
        <h4 class="no-results" *ngIf="noResultsMessage">No results were found.</h4>
        <h4 class="no-results" *ngIf="resultsErrorMessage">Timeout error: Please try again.</h4>
      </div>
      <div class="cant_find">
        Not the right venue? <span class="secondary_link" (click)="revertMode()">Search again</span> with a more specific location.
      </div>
    </div>
    <ng-container *ngIf="mode == 'selected' || mode == 'edit'">
      <form>
        <mat-form-field class="general">
          <input #venueNameInput type="text" matInput autocomplete="off"
            placeholder="Venue name"    
            [formControl]="venueControl"
            (change)="setValueDirectly($event)">
        </mat-form-field>
      </form>
      <h5>Venue Address</h5>
      <div style="padding: 5px 0 20px;">{{ editingVenue.address }}</div>
      <div class="map-wrapper" >
        <h5 class="hidden_loading">Loading...</h5>
        <iframe *ngIf="!!googleMapsLink"
          class="map-holder"
          frameborder="0" 
          style="border:0; width: 260px;"
          [src]="googleMapsLink" 
          allowfullscreen>
        </iframe>
      </div>
<!--       <div *ngIf="!isNew" class="researchBtn" (click)="reSearch()">
        <icon [icon]="'map_search'" (click)="reSearch()"></icon> <span class="link_text">Search for venue</span>
      </div> -->
    </ng-container>
  </div>
</ng-container>
<add-manage-wrapper 
  *ngIf="mode === 'select'"
  [readOnly]="!event || !!event.is_readonly"
  [openLabel]="'+ CREATE A NEW ' + capitalType" 
  [hideHRule]="true"
  (open)="editNewType()" 
  >
  <div class="empty-text" *ngIf="!data.venues.length">No {{ lowerCaseType }}s in this event</div>
  <div 
    class="venues" 
    *ngFor="let venue of data.venues"
    >
    <div class="label" (click)="select(venue)" [ngClass]="{ selected: data.selectedVenueId === venue.id }">
      <div class="name">
        <div class="venue">{{ venue.venue }}</div>
        <div class="address" *ngIf="venue.address">{{ venue.address }}</div>
      </div>
      <div style="flex:1"></div>
      <icon class="check" [ngClass]="{selected: true, invisible: data.selectedVenueId !== venue.id}" icon="tick_24px"></icon>
    </div> 
    <icon *ngIf="event && !event.is_readonly" class="edit" (click)="editOldVenue(venue)" matIcon="edit"></icon>
  </div>
</add-manage-wrapper>

</dialog-wrapper>
  `,
    styleUrls: ['./venue-select.scss'],
    standalone: true,
    imports: [
      DialogWrapperComponent,
      AddManageWrapperComponent,
      MatFormFieldModule,
      ReactiveFormsModule,
      IconComponent,
      CommonModule,
      MatDialogModule,
      MatButtonModule,
      MatInputModule,
      FormsModule,
    ],
})
export class VenueSelectDialogComponent extends Wrapper<VenueSelectDialogComponent> implements OnInit {
  value: string
  mode: 'select' | 'search' | 'results' | 'selected' | 'replace' | 'edit' | 'new' = 'select';
  showNext = false;
  editingVenue: Venue
  capitalType: string
  lowerCaseType: string
  event: JoiEvent
  searchResultsShowing:boolean
  googleMapsLink: SafeResourceUrl
  cachedUnsanitizedLinksByVenueId: { [id: string]: string } = {}
  previousGoogleMapsUnsanitizedLink: string = null
  venueControl = new UntypedFormControl()
  venueSearchControl = new UntypedFormControl()
  venueAddressControl = new UntypedFormControl()
  results: PlaceResult[]
  previousResult: string
  debounceTime = 400
  searching = false
  isNew = false;
  sleepDelay = 100;
  noResultsMessage = false
  resultsErrorMessage = false
  noResultsDisplayMS = 10000
  @ViewChild('venueNameInput') venueNameInput: ElementRef<HTMLInputElement>
  @ViewChild('searchInput') searchInput: ElementRef<HTMLInputElement>

  @ViewChild(DialogWrapperComponent, { static: true }) dialogWrapper: DialogWrapperComponent

  startingVenuesString: string

  constructor(
    public dialogRef: MatDialogRef<VenueSelectDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: VenueDialogData,
    private sanitizer: DomSanitizer
  ) {
    super()
    this.data.dialogRef = dialogRef
    this.startingVenuesString = JSON.stringify(data.venues)
    dialogRef.backdropClick().subscribe(() => { this.close() })
    this.subProp(this.store.select('events', 'event'), 'event')  
  }

  resetLinks() {
    this.googleMapsLink = null;
    this.previousGoogleMapsUnsanitizedLink = null
  }

  revertMode() {
    switch(this.mode){
      case 'search':
        this.mode = 'select';
        this.resetLinks()
        break;
      case 'results':
        this.mode = this.isNew ? 'search' : 'replace';
        this.results = [];
        this.resetLinks()
        break;
      case 'selected':
        this.mode = 'results';
        this.resetLinks()
        break;
      case 'replace':
        this.mode = 'edit';
        break;
      case 'edit':
        this.mode = 'select';
        break;
    }
    // this.mode = 'select'
    // this.googleMapsLink = '';
    // this.showNext = false;
    this.dialogWrapper.fitChildrenWithDelay(200)
  }

  dialogSubmit(){
    switch(this.mode){
      case 'search':
      case 'replace':
        this.searchForPlace();
        break;
      case 'results':
        break;
      case 'selected':
        this.addNewVenue();
        break;
      default:
        this.updateVenue()
    }
  }

  editNewType() {
    if (!this.editingVenue) this.editingVenue = { id: null, venue: '', address:'', latitude:null, longitude:null, timeZoneId: this.programService.getDefaultTimeZoneDetails().timeZoneId } // id needs to be set for each result.
    this.mode = 'search'
    this.isNew = true;
    this.googleMapsLink = null;
    this.results = [];
    this.venueSearchControl.setValue('')
    this.dialogWrapper.fitChildrenWithDelay(200)
    setTimeout(_=>{
      this.searchInput.nativeElement.focus();
    }, 0)
  }

  editOldVenue(venue: Venue) {
    this.editingVenue = jsonCopyObject(venue)
    this.isNew = false;
    this.mode = 'edit';
    this.venueAddressControl.setValue(this.editingVenue.address);
    this.showNext = false;
    this.setInputValue(this.editingVenue.venue);
    this.getMapLink();
    this.dialogWrapper.fitChildrenWithDelay(200)
    setTimeout(_=>{
      this.venueNameInput.nativeElement.focus();
    }, 0)
  }

  async updateVenue() {
    await sleepForMS(this.sleepDelay)
    const typeIndex = this.data.venues.findIndex(l => l.id === this.editingVenue.id)
    this.data.venues[typeIndex] = this.editingVenue
    this.mode = 'select'
    this.showNext = false;
    this.editingVenue = null
    this.data.selectedVenueId = null; // this forces the user to select it again, which will close the dialog properly
    this.dialogWrapper.fitChildrenWithDelay(200)
  }

  async deleteVenue(event) {
    const data: ConfirmDeleteData = {
      title: `Delete ${this.lowerCaseType} in this event`,
      para: `All references to this ${this.lowerCaseType} will be deleted in this event`,
      deleteButtonText: 'DELETE',
      dialog: this.dialog,
      rect: event.target.getBoundingClientRect()
    }
    const del = await openConfirmDeleteGetResult(data)
    if (!del) return
    removeFromListByIndex(this.data.venues, this.data.venues.findIndex(l => l.id === this.editingVenue.id))
    this.mode = 'select'
    this.editingVenue = null
    this.dialogWrapper.fitChildrenWithDelay(300)
  }

  addNewVenue() {
    this.data.venues.push(this.editingVenue)
    this.mode = 'select'
    this.showNext = false;
    this.editingVenue = null
    this.dialogWrapper.fitChildrenWithDelay(300)
  }

  async addNewManualVenue() {
    this.editingVenue.venue = this.venueControl.value;
    this.editingVenue.address = this.venueAddressControl.value;
    await sleepForMS(this.sleepDelay)
    this.addNewVenue()
  }

  ngOnInit() {
    this.capitalType = this.data.type.toUpperCase()
    this.lowerCaseType = this.data.type.toLowerCase()
  }

  getMapLink() {
    if (!this.editingVenue || !this.event) return
    const googleMapsLink = this.cachedUnsanitizedLinksByVenueId[this.editingVenue.id] || getEmbeddedMapLinkFromVenue(this.editingVenue, environment.firebase.apiKey)
    if (googleMapsLink) {
      if (this.previousGoogleMapsUnsanitizedLink === googleMapsLink) return
      const sanitizedLink = this.sanitizer.bypassSecurityTrustResourceUrl(this.sanitizer.sanitize(SecurityContext.URL, googleMapsLink))
      this.googleMapsLink = sanitizedLink
      this.cachedUnsanitizedLinksByVenueId[this.editingVenue.id] = googleMapsLink
      console.log({ cachedLinks: this.cachedUnsanitizedLinksByVenueId, editingVenue: this.editingVenue })
      this.previousGoogleMapsUnsanitizedLink = googleMapsLink
    } else {
      this.googleMapsLink = null
      this.previousGoogleMapsUnsanitizedLink = null
    }
  }

  async changeVenueName(name: string) {
    this.editingVenue.venue = name
  }

  async changeVenueDetails(venueDetails: PlaceResult) {
    const { name, formatted_address, longitude, latitude, googleId } = venueDetails
    const timeZoneId = (await this.locationService.getTimeZonesFromLatLong(latitude, longitude))[0]
    this.editingVenue.venue = name
    this.editingVenue.address = formatted_address
    this.editingVenue.timeZoneId = timeZoneId
    this.editingVenue.longitude = longitude
    this.editingVenue.latitude = latitude
    this.editingVenue.googleId = googleId
    this.getMapLink();
    this.showNext = false;
  }
  // showingResults(is_showing){
  //   console.log({ is_showing});
  //   this.searchResultsShowing = is_showing;
  // }
  async setValueDirectly($event) {
    const value = $event.target ? $event.target.value : $event.source.value
    await sleepForMS(this.sleepDelay)
    this.venueControl.setValue(value || '')
    if(this.editingVenue) this.editingVenue.venue = value;
  }

  setInputValue(value: string) {
    this.venueControl.setValue(value || '')
  }

  async choosePlace(result: PlaceResult) {
    // console.log({ result});
    // this.choosingPlace = true
    this.setInputValue(result.name)
    this.editingVenue.id = createId() // needs to be set each time
    // this.showNext = false;
    this.mode = this.isNew ? 'selected' : 'edit';
    // this.results = null // have to do this or get strange behaviour

    const { latitude, longitude } = result
    result.googleId = result.place_id
    // this.showingResults(false);
    this.changeVenueDetails(result)
  }

  async searchForPlace() {
    const input = this.searchInput.nativeElement
    const searchTerm = this.venueSearchControl.value
    console.log({ searchTerm});
    if (!searchTerm) {
      return
    }
    this.noResultsMessage = false
    this.resultsErrorMessage = false;
    this.mode = 'results';
    // this.googleMapsLink = null;
    // this.searching = true
    this.results = null;
    const results: {error:string} | PlaceResult[] = await this.locationService.findPlacesFromTextWithGoogle(searchTerm)   
    console.log({ results});
    if(results && results.hasOwnProperty('error') && results['error'] !== 'ZERO_RESULTS'){
      console.log({ error:results['error']});
      this.resultsErrorMessage = true;
      this.killGoogleMapsPlacesScriptsAndReload();
    }else if (!results || !results['length']) {
      this.noResultsMessage = true
    }else{
      this.results = results as PlaceResult[];
    }
  }


  checkForChangesToSave() {
    if (this.startingVenuesString !== JSON.stringify(this.data.venues)) {
      console.log("VENUES HAVE CHANGED")
      this.eventService.updateEvent(this.event.eventId, { venues: makeMapFromListOfObjectsAndKey(this.data.venues, 'id') })
    }
  }

  close() {
    this.checkForChangesToSave()
    this.dialogRef.close()
  }

  select(venue: Venue) {
    const deselecting = venue.id === this.data.selectedVenueId
    if (deselecting) this.data.selectedVenueId = null
    else this.data.selectedVenueId = venue.id
    if (this.data.closeOnChoice) {
      this.checkForChangesToSave()
      this.dialogRef.close({ venue: deselecting ? null : venue })
    }
  }

  killGoogleMapsPlacesScriptsAndReload(){
    let initSrc;
    window.google = undefined;
    const oldScripts = document.getElementsByTagName('script');
    for (let i = oldScripts.length - 1; i >= 0; i--) {
      const script = oldScripts[i];
      if(script.src && script.src.split('https://maps.googleapis.com/maps').length > 1){
        if(/libraries=places/.test(script.src)) initSrc = script.src;
        script.remove();
      } 
    }
    console.log({ initSrc});
    if(initSrc) addScriptToDocumentBySource(initSrc);
  }

}

export interface VenueDialogData {
  venues: Venue[]
  type: 'Venue'
  selectedVenueId: string
  position: DialogPositionNumbers
  closeOnChoice: boolean
  dialogRef: MatDialogRef<VenueSelectDialogComponent>
}
export type LocationInputType = 'name' | 'address'
